export class Cancelacion {

    model = {
        id: {value: null, export: false},
        detalle: {value: '', export: false, header: 'Justificación', required: 'Campo requerido',
            maxLength: 'Máximo 300 caracteres', minLength: 'Mínimo 4 caracteres', max: 300, min: 4},
    }
}
